import React, { Component } from 'react';
import { Loader, Table } from 'semantic-ui-react';
import ThreeColumnTableRow from '../../../Admin/CreateCourse/ThreeColumnTableRow';
import moment from 'moment';
import TableRow from '../../../Admin/CreateCourse/TableRow';
import EditProperty from './EditProperty';

class Info extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Table celled unstackable compact>
                    { this.state.edit ?
                        <EditProperty closeEditMode={() => this.setState({ edit: false })} />
                        :
                        <Table.Body>
                            <ThreeColumnTableRow
                                oneCol
                                icon
                                disabled
                                onClick={() => this.setState({ edit: true })}
                            />
                            <ThreeColumnTableRow
                                name="Organizaciona jedinica"
                                keyName="orgUnit"
                                value={this.props.orgUnitProperty.organizationalUnit.name}
                            />
                            <ThreeColumnTableRow
                                name="Adresa"
                                keyName="address"
                                value={this.props.orgUnitProperty.property.address.street + ', ' +
                                this.props.orgUnitProperty.property.address.place.name + ', ' +
                                this.props.orgUnitProperty.property.address.place.municipality.name + ', ' +
                                this.props.orgUnitProperty.property.address.place.canton.name + ', ' +
                                this.props.orgUnitProperty.property.address.place.entity.name + ', ' +
                                this.props.orgUnitProperty.property.address.place.country.name
                                }
                            />
                            <ThreeColumnTableRow
                                name="Naziv imovine"
                                keyName="property"
                                value={this.props.orgUnitProperty.property.name}
                            />

                            <ThreeColumnTableRow
                                name="Tip prava"
                                keyName="rightType"
                                value={this.props.orgUnitProperty.rightType.name}
                            />
                            <ThreeColumnTableRow
                                name="Korisna površina (m²)"
                                keyName="usefulSurface"
                                value={this.props.orgUnitProperty.usefulSurface}
                            />
                            <ThreeColumnTableRow
                                name="Površina površina (m²)"
                                keyName="teachingArea"
                                value={this.props.orgUnitProperty.teachingArea}
                            />
                            <ThreeColumnTableRow
                                name="Pristup invalidima"
                                keyName="disabledAccess"
                                value={this.props.orgUnitProperty.disabledAccess.name}
                            />
                        </Table.Body>}
                </Table>
            </div>
        );
    }
}

export default Info;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/Info.js